import { useSelector } from "react-redux";
import { ReactComponent as CollegeSVG } from "../../assets/college.svg";
import TimelineBox from "./TimelineBox";
import classNames from "classnames";

const colorClasses = ["cyan-bg", "blue-bg", "red-bg"];

function Timeline({ className }) {
  const { timelineData } = useSelector((state) => state.app);
  const timelineBoxes = [];
  let i = 0;
  while (i < timelineData.length) {
    if (i + 1 < timelineData.length) {
      timelineBoxes.push([
        <div
          className={classNames("timeline-circle", colorClasses[i % 3])}
          key={i}
        >
          <TimelineBox
            className="timeline-box-up"
            timelineBoxData={timelineData[i]}
          />
        </div>,
        <div className="timeline-start-line" key={`line${i}`}></div>,
      ]);
      i++;
      timelineBoxes.push([
        <div
          className={classNames("timeline-circle", colorClasses[i % 3])}
          key={i}
        >
          <TimelineBox
            className="timeline-box-down"
            timelineBoxData={timelineData[i]}
          />
        </div>,
        <div className="timeline-line" key={`line${i}`}></div>,
      ]);
      i++;
    } else {
      timelineBoxes.push([
        <div
          className={classNames("timeline-circle", colorClasses[i % 3])}
          key={i}
        >
          <TimelineBox
            className="timeline-box-up timeline-box-right"
            timelineBoxData={timelineData[i]}
          />
        </div>,
        <div className="timeline-end-line" key={`line${i}`}></div>,
      ]);
      i++;
    }
  }
  return (
    <div className={classNames("flex flex-row items-center w-max", className)}>
      {timelineBoxes}
      <div className="timeline-college">
        <CollegeSVG />
      </div>
    </div>
  );
}

export default Timeline;
